module.exports = __webpack_public_path__ + "static/media/duel.646828b1.png";